// eslint-disable-next-line no-unused-vars
import Image from 'next/image'

const Loader = ({ size = 40, variant = 'primary' }) => {
  const loaderSrc =
    variant === 'white'
      ? '/static/images/white-loader.svg'
      : '/static/images/match-maker/loader.svg'

  return (
    <div className='flex items-center justify-center'>
      <Image
        src={loaderSrc}
        alt='loading'
        width={size}
        height={size}
        className='animate-spin'
        style={{ animationDuration: '2s' }}
      />
    </div>
  )
}

export { Loader }
